import React from "react"
import { Redirect } from "@reach/router"

const IndexPage = () => {
  return <Redirect to={`/home/`} noThrow />
}
export default IndexPage
